import { Star, Quote } from "lucide-react";
import { Section } from "@/components/ui/Section";
import { Card } from "@/components/ui/Card";
import { Reveal } from "@/components/common/Reveal";
import { REVIEWS } from "@/utils/constants";

export const Reviews = () => (
  <Section id="reviews" testId="reviews-section" bg="ink">
    <Reveal>
      <p className="text-weld-glow font-semibold tracking-[0.25em] uppercase text-sm mb-3">Customer Reviews</p>
      <h2 className="font-display text-5xl md:text-6xl text-white">Five-Star Craft</h2>
    </Reveal>

    <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {REVIEWS.map((r, i) => (
        <Reveal key={r.name} delay={(i % 3) * 0.06}>
          <Card data-testid={`review-card-${i}`} className="p-7 h-full relative">
            <Quote className="absolute top-6 right-6 text-weld/15" size={40} />
            <div className="flex gap-1 mb-4">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} size={16} className="text-weld-glow fill-weld-glow" />
              ))}
            </div>
            <p className="text-white/75 text-sm leading-relaxed mb-5">"{r.text}"</p>
            <div>
              <p className="font-bold text-white">{r.name}</p>
              <p className="text-white/40 text-xs uppercase tracking-wider">{r.role}</p>
            </div>
          </Card>
        </Reveal>
      ))}
    </div>
  </Section>
);
